/// <amd-module name="Artifacts/Nuget/redux/Module" />

import { rootSaga } from "Artifacts/Nuget/redux/Sagas";
import { PackageModule } from "Artifacts/Package/redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _NugetModule: ISagaModule<Record<string, never>> = {
  id: "nuget-protocol-module",
  reducerMap: {},
  sagas: [rootSaga],
};

export const NugetModule = [PackageModule, _NugetModule];
